import { createApi } from '@reduxjs/toolkit/query/react';

import {
  ControlInfo,
  ControlInfoPayload,
} from '@/pages/Vaccination/components/control/types';
import { PageableRequest, PageableResponse } from '@/shared/api/types';
import { TASK_CONTROL, TASK_CONTROL_INFO } from '@/shared/vaccination/api';

import { baseQueryWithReAuth } from '../../baseApi';
import { vaccinationControlTags } from './tags';

export const vaccinationControlApi = createApi({
  reducerPath: 'vaccinationControlApi',
  baseQuery: baseQueryWithReAuth,
  tagTypes: Object.values(vaccinationControlTags),
  endpoints: (builder) => ({
    getControlInfo: builder.query<ControlInfo, ControlInfoPayload>({
      query: (payload) => ({
        url: TASK_CONTROL_INFO,
        method: 'GET',
        params: {
          ...payload,
        },
      }),
    }),
    getControlData: builder.query<
      PageableResponse<ControlInfo>,
      PageableRequest<ControlInfoPayload>
    >({
      queryFn: async (payload, _api, _opt, baseQuery) => {
        const result = await baseQuery({
          url: TASK_CONTROL,
          method: 'GET',
          params: {
            ...payload.filters,
            page: payload?.paging?.page,
            size: payload?.paging?.size,
          },
        });

        return { data: result?.data as PageableResponse<ControlInfo> };
      },
      providesTags: [vaccinationControlTags.CONTROL],
    }),
  }),
});

export const { useGetControlInfoQuery, useGetControlDataQuery } = vaccinationControlApi;
